import Vue from 'vue';
import VueRouter from 'vue-router';
import { auth } from '../firebase';
import Dashboard from '../views/Dashboard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import(/* webpackChunkName: "clients" */ '../views/Clients.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clients/new',
    name: 'new-client',
    component: () => import(/* webpackChunkName: "new-client" */ '../views/Client/Register.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clients/:id',
    name: 'client',
    component: () => import(/* webpackChunkName: "new-client" */ '../views/Client/Profile.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:slug',
    name: 'project',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Project.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/sales-funnel',
    name: 'sales-funnel',
    component: () => import(/* webpackChunkName: "projects" */ '../views/SalesFunnel.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/teams',
    name: 'teams',
    component: () => import(/* webpackChunkName: "teams" */ '../views/Teams.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/teams/:slug',
    name: 'team',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Team.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "login" */ '../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);

  if (requiresAuth && !auth.currentUser) {
    next('/login');
  } else {
    next();
  }
});

export default router;
